//* English. Translated by: Jack O'Connor (jackocnr).
export default {
  selectedCountryAriaLabel: "Selected country",
  noCountrySelected: "No country selected",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo",
};
